import style from 'src/component/util/full-screen-loader.module.scss';
import { Spinner } from 'src/component/util/spinner';

export const FullScreenLoader = (): JSX.Element => {
	return (
		<div className={style.loader}>
			<Spinner />
		</div>
	);
};
